<template>
  <div class="standings-list-section">
    <template v-if="standingsPlayerList && standingsPlayerList.length > 0">
      <standings-list-player-parts
        class="standings-list-section__item"
        v-for="(player, index) in standingsPlayerList"
        :key="`standingsListPlayer${index}`"
        :standingsPlayer="player"
      />
    </template>
    <template v-else>
      <p class="standings-list-section__no-data" v-html="$tc('StandingsPage.noData')"></p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import StandingsListPlayerParts, {
  StandingsPlayerDataType,
} from '@/components/StandingsPage/StandingsTopPane/parts/StandingsListPlayerParts.vue'

/**
 * Standings: 選手リストセクション
 */
export default defineComponent({
  name: 'StandingsListSection',
  components: {
    StandingsListPlayerParts,
  },
  props: {
    standingsPlayerList: {
      type: Array as PropType<StandingsPlayerDataType[]>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.standings-list-section {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-items: flex-start;
  width: 100%;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  margin: 0 auto;
  overflow-y: auto;

  &__no-data {
    padding: 7px 0;
    font-family: $fontSignup;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray50;
  }
}
</style>
